const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export function getAdminToken() {
  return localStorage.getItem('fpb_admin_token') || localStorage.getItem('adminToken') || localStorage.getItem('admin_token') || '';
}

export async function adminApi(path, options = {}) {
  const token = getAdminToken();
  const isFormData = options.body instanceof FormData;

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  const text = await response.text();
  let data = {};

  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { message: text || 'Unexpected server response' };
  }

  if (!response.ok) {
    throw new Error(data.error || data.message || `Request failed with status ${response.status}`);
  }

  return data;
}

export function publicAssetUrl(path) {
  if (!path) return '';
  const value = String(path).trim();
  if (!value) return '';
  if (/^(https?:|data:|blob:|mailto:|tel:)/i.test(value)) return value;
  const cleaned = value.replace(/\\/g, '/');
  if (cleaned.startsWith('/uploads/')) return `${API_BASE}${cleaned}`;
  if (cleaned.startsWith('uploads/')) return `${API_BASE}/${cleaned}`;
  const uploadIndex = cleaned.indexOf('/uploads/');
  if (uploadIndex >= 0) return `${API_BASE}${cleaned.slice(uploadIndex)}`;
  const uploadNoSlashIndex = cleaned.indexOf('uploads/');
  if (uploadNoSlashIndex >= 0) return `${API_BASE}/${cleaned.slice(uploadNoSlashIndex)}`;
  return value;
}

